import config from '../../appConfig';
import ajax from "../services/ajax";

export const PPABridge = (action, target, data) =>
  ajax(`${config.apiUrl}bridge`, null, JSON.stringify({
    action,
    target,
    data
  }))

window.PPABridge = PPABridge



// WEBPACK FOOTER //
// ./src/utils/bridge.js